import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class MeclisKararlariAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "MeclisKararlariListe";
        super(baseUrl);
    }
    getMeclisKararlariListe(ilkTarih: string, sonTarih: string, kararNo: string, Icerik: string) {
        return this.get("", { params: { ilkTarih: ilkTarih, sonTarih: sonTarih, kararNo: kararNo, Icerik: Icerik } });
    }
}
export default new MeclisKararlariAPI();
